import React from "react";
import { useApplyListModel } from "../applyListModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useOrgModel } from "@/views/base/organization/orgModel";




export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useApplyListModel();
    const { getOrgTreeSelect } = useOrgModel(() => [])
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "申请单号",
            fieldName: "code",
            span:3
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "申请人员",
            fieldName: "createUser",
            span:3
        }, {
            type: SearchTypeEnum.TreeSelect,
            placeholder: "申请部门",
            fieldName: "department",
            span:3,
            treeData: getOrgTreeSelect(DictCodeEnmu.ORG)
        }, {
            type: SearchTypeEnum.Input,
            placeholder: "名称",
            fieldName: "supplierName",
            span:3
        },{
            type: SearchTypeEnum.Select,
            placeholder: '申请状态',
            fieldName: 'status',
            options: getSelectedDictOne(DictCodeEnmu.ASSETS_APPLY_STATUS),
            span:3,
            showSearch:true,
        }, {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["申请起始日期", "申请结束日期"],
            format: "YYYY-MM-DD",
            alloc: true,
            span:4
        }, 
    ]

    return (
        <YhPageHeader
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}